import { type Filter, FilterType } from '../types/filters';

export const getListFilter = <T extends Record<string, unknown>>(
  filter: Filter,
  key: keyof T
) => {
  if (filter.type !== FilterType.LIST) return {};
  return {
    // biome-ignore lint/correctness/useParseIntRadix: migrated from develop
    [key]: filter.selections.map((selection) => parseInt(selection.id)),
  };
};
